/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from 'react';
import { useTheme } from '../../theme/ThemeContext';

function UseCasesSection() {
    const { theme } = useTheme();

    const useCases = [
        {
            title: 'ERP Organization Wide',
            description: 'Unify operations across Sales, Supply Chain, HR, and Finance into a single source of truth.'
        },
        {
            title: 'B2B & Partner Portals',
            description: 'Secure, role-based gateways for vendors, partners, and customers to interact with your data.'
        },
        {
            title: 'Data Engineering Endpoints',
            description: 'Use Arcee as the front door and tenancy layer for data products, exposing curated data domains (assortment, demand, supply, etc.) to business users.'
        }
    ];

    return (
        <section id="use-cases" className="use-cases-section" style={{ padding: '80px 0', background: '#fff' }}>
            <div className="container">
                <div style={{ textAlign: 'center', marginBottom: '48px' }}>
                    <h3 style={{ fontSize: '2rem', fontWeight: 700, color: theme.primary, marginBottom: '16px' }}>
                        Ideal For...
                    </h3>
                </div>

                <div className="row g-4">
                    {useCases.map((useCase, index) => (
                        <div key={index} className="col-md-4">
                            <div
                                style={{
                                    padding: '32px',
                                    background: '#f8f9fa',
                                    borderRadius: theme.cardRadius,
                                    height: '100%',
                                    borderTop: `4px solid ${theme.secondary}`
                                }}
                            >
                                <h4 style={{ fontWeight: 700, color: theme.primary, marginBottom: '16px', fontSize: '1.3rem' }}>
                                    {useCase.title}
                                </h4>
                                <p style={{ color: '#666', margin: 0, lineHeight: 1.7 }}>
                                    {useCase.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default UseCasesSection;
